import { createSlice } from "@reduxjs/toolkit";

const routingSlice = createSlice({
  name: 'routingSlice',
  initialState: {
    isLogoutContext: false, // 👈 Este es el interruptor
  },
  reducers: {
    logout: (state) => {
      state.isLogoutContext = true
    },
    resetLogoutContext: (state) => {
      state.isLogoutContext = false; // Para limpiar el estado después de usarlo
    }
  }
});

export const { logout,resetLogoutContext } = routingSlice.actions;
export default routingSlice.reducer;